// extracted by mini-css-extract-plugin
module.exports = {"root":"Label_root__1-b53","text":"Label_text__1StrW","required":"Label_required__3S5ll","errorWrapper":"Label_errorWrapper__t2THp","errorText":"Label_errorText__3LnxK"};